<template>
  <generic-modal
    :title="$t('personality')"
    ref="generic_modal"
    size="fullscreen"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control has-icons-left has-icons-right">
              <input
                class="input"
                type="text"
                :placeholder="$t('assistant name')"
                v-model="meta.name"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-user"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="column" v-if="meta.settings">
          <div class="field">
            <label class="label">{{ $t("service") }}</label>
            <div class="select is-fullwidth">
              <select v-model="meta.settings.ai_service">
                <option value="openai">{{ $t("openai") }}</option>
                <option value="deepseek">{{ $t("deepseek") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column" v-if="meta.settings">
          <div class="field">
            <label class="label">{{ $t("engine") }}</label>
            <div class="select is-fullwidth">
              <select v-model="meta.settings.ai_engine">
                <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>
                <option value="gpt-4">gpt-4</option>
                <option value="gpt-4-32k">gpt-4-32k</option>
                <option value="deepseek-chat">deepseek-chat</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div v-if="meta.settings && meta.settings.init_result" class="box mt-4">
        <article class="media">
          <figure class="media-left">
            <span class="icon">
              <i class="fa fa-android"></i>
            </span>
          </figure>
          <div class="media-content">
            <div class="content">
              <div>
                <strong>{{ $t("assistant") }}</strong>
                <br />
                <div>{{ meta.settings.init_result }}</div>
              </div>
            </div>
          </div>
        </article>
      </div>
      <div v-else>
        <div class="notification is-warning">
          <p>{{ $t("this personality is not initialized yet") }}</p>
        </div>
      </div>

      <div class="tabs is-toggle is-fullwidth" ref="tabs">
        <ul>
          <li
            class="is-active"
            data-tab="prompt"
            @click="change_active_tab($event, this)"
          >
            <a>
              <i class="terminal icon" aria-hidden="true"></i>
              <span>{{ $t("prompt") }}</span>
            </a>
          </li>
          <!-- <li data-tab="purpose" @click="change_active_tab($event, this)">
            <a>
              <i class="list icon" aria-hidden="true"></i>
              <span>{{ $t("purpose") }}</span>
            </a>
          </li>
          <li data-tab="information" @click="change_active_tab($event, this)">
            <a>
              <i class="info icon" aria-hidden="true"></i>
              <span>{{ $t("information") }}</span>
            </a>
          </li>
          <li data-tab="key_functions" @click="change_active_tab($event, this)">
            <a>
              <i class="key icon" aria-hidden="true"></i>
              <span>{{ $t("key functions") }}</span>
            </a>
          </li> -->
          <li data-tab="actions" @click="change_active_tab($event, this)">
            <a>
              <i class="bolt icon" aria-hidden="true"></i>
              <span>{{ $t("actions") }}</span>
            </a>
          </li>
        </ul>
      </div>
      <div class="is-fluid" ref="contents">
        <div class="" data-tab="prompt">
          <div class="field" v-if="meta.settings">
            <vue-monaco-editor
              v-model:value="meta.settings.prompt"
              theme="vs-dark"
              language="markdown"
              :options="{
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                tabSize: 2,
                scrollBeyondLastLine: false,
                folding: true,
                bracketPairColorization: true,
                autoClosingBrackets: 'always',
                autoIndent: 'full',
              }"
              style="height: 500px"
            />
          </div>
        </div>
        <div class="is-hidden" data-tab="purpose">
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("purpose") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                :placeholder="$t('assistant purpose')"
                v-model="meta.settings.purpose"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="is-hidden" data-tab="information">
          <div class="field" v-if="meta.settings">
            <vue-monaco-editor
              v-model:value="meta.settings.information"
              theme="vs-dark"
              language="json"
              :options="{
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                tabSize: 2,
                scrollBeyondLastLine: false,
                folding: true,
                bracketPairColorization: true,
                autoClosingBrackets: 'always',
                autoIndent: 'full',
              }"
              style="height: 500px"
            />
            <!-- <label class="label">{{ $t("information") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                placeholder="{'description': 'module description', 'anything_needed': { 'key': 'value' }}"
                v-model="meta.settings.information"
              ></textarea>
            </div> -->
          </div>
        </div>
        <div class="is-hidden" data-tab="key_functions">
          <div class="field" v-if="meta.settings">
            <vue-monaco-editor
              v-model:value="meta.settings.key_functions"
              theme="vs-dark"
              language="json"
              :options="{
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                tabSize: 2,
                scrollBeyondLastLine: false,
                folding: true,
                bracketPairColorization: true,
                autoClosingBrackets: 'always',
                autoIndent: 'full',
              }"
              style="height: 500px"
            />
            <!-- <label class="label">{{ $t("key functions") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                :placeholder="
                  $t(
                    'explain what is and how it works, describe our services, etc'
                  )
                "
                v-model="meta.settings.key_functions"
              ></textarea>
            </div> -->
          </div>
        </div>
        <div class="is-hidden" data-tab="actions">
          <div class="field">
            <generic-dropdown
              :title="$t('actions')"
              :placeholder="$t('select one')"
              :is_multiple="true"
              url="/assistant/function/catalog"
              name_field="name"
              value_field="function_id"
              @selected="functions_changed"
              ref="functions_dropdown"
            />
          </div>
          <div class="field" v-if="meta.settings">
            <vue-monaco-editor
              v-model:value="meta.settings.actions"
              theme="vs-dark"
              language="json"
              :options="{
                automaticLayout: true,
                formatOnType: true,
                formatOnPaste: true,
                tabSize: 2,
                scrollBeyondLastLine: false,
                folding: true,
                bracketPairColorization: true,
                autoClosingBrackets: 'always',
                autoIndent: 'full',
              }"
              style="height: 500px"
            />
            <!-- <label class="label">{{ $t("actions") }}</label>
            <div class="control">
              <textarea
                class="textarea"
                placeholder="{}"
                v-model="meta.settings.actions"
              ></textarea>
            </div> -->
          </div>
        </div>
      </div>

      <!-- <div class="button is-primary mt-4" @click="init">
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("init") }}</span>
      </div> -->

      <!-- <div v-if="meta.settings && meta.settings.messages">
        <div class="title is-6">{{ $t("messages") }}</div>
        <div
          class="box p-4 mb-2"
          :class="{
            'has-text-right': message.role === 'assistant',
          }"
          v-for="(message, index) in meta.settings.messages"
          :key="index"
        >
          <article class="media">
            <figure class="media-left">
              <span class="icon">
                <i
                  :class="
                    ['developer', 'system'].includes(message.role)
                      ? 'fa fa-user'
                      : 'fa fa-android'
                  "
                ></i>
              </span>
            </figure>
            <div class="media-content">
              <div class="content">
                <div>
                  <strong>{{ $t(message.role) }}</strong>
                  <br />
                  <div v-if="!message.is_editing">{{ message.content }}</div>
                  <div v-if="message.is_editing">
                    <textarea
                      class="textarea"
                      rows="4"
                      v-model="message.content"
                    ></textarea>
                  </div>
                </div>
                <div class="buttons are-small is-pulled-right">
                  <div class="button" v-if="!message.is_editing">
                    <span
                      class="icon is-small"
                      @click="edit_message(message, index)"
                      v-if="message.role != 'assistant'"
                    >
                      <i class="fa fa-edit"></i>
                    </span>
                  </div>
                  <div class="button" v-if="message.is_editing">
                    <span
                      class="icon is-small"
                      @click="message.is_editing = false"
                    >
                      <i class="fa fa-check"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </div>
      </div> -->
      <!-- <div class="field has-addons">
        <div class="control is-expanded has-icons-left has-icons-right">          
          <input
            class="input"
            type="text"
            :placeholder="$t('interact with assistant writing here')"
            v-model="meta.prompt"
            @keyup="keyup"
          />
          <span class="icon is-small is-left">
            <i class="fa fa-terminal"></i>
          </span>
        </div>
        <div class="control">
          <div class="button is-primary is-right" @click="send_prompt">
            <span class="icon is-small">
              <i class="fa fa-send"></i>
            </span>
          </div>
        </div>
      </div>
      <article class="message is-info">
        <div class="message-header">
          <p>{{ $t("information") }}</p>
        </div>
        <div class="message-body">
          <p>
            {{
              $t(
                "you can interact with your assistant in the prompt input above"
              )
            }}
          </p>
          <p>
            {{
              $t(
                "remember: you can tell to assistant 'ask me if you have any question'"
              )
            }}
          </p>
        </div>
      </article> -->
      <!-- <pre>{{ meta }}</pre> -->
      <!-- <p class="help is-success">This username is available</p>
        <div class="control">
          <input class="input" type="text" v-model="meta.prompt" />
        </div> -->
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-info is-rounded"
        @click="init_prompt"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-bolt"></i>
        </span>
        <span>{{ $t("init") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  change_active_tab,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import { VueMonacoEditor } from "@guolao/vue-monaco-editor";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "RequestModal",
  components: { GenericModal, VueMonacoEditor, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name ||
        !v.meta.settings ||
        !v.meta.settings.ai_service ||
        !v.meta.settings.ai_engine ||
        !v.meta.settings.prompt
      );
    },
  },
  methods: {
    change_active_tab,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/assistant/personality", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.settings.messages = data.settings.messages.map((m) => {
        delete m.is_editing;
        return m;
      });
      if (!v.meta.uuid)
        put("/assistant/personality", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/assistant/personality", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    send_prompt() {
      let v = this;
      // if (!v.meta.uuid)
      v.$root.loader(true);
      post("/assistant/personality/instruct", v.meta)
        .then((r) => {
          v.meta.settings.messages.push({
            role: "developer",
            content: v.meta.prompt,
          });
          if (typeof r != "string") r = JSON.stringify(r);
          v.meta.settings.messages.push({
            role: "assistant",
            content: r,
          });
          v.meta.prompt = "";
        })
        .catch((error) => {
          console.log("error", error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        // prompt: "",
        settings: {
          prompt: "",
          messages: [],
          // purpose: "",
          // information: "",
          // key_functions: "",
          actions: "",
        },
      };
      v.error = "";
      v.$refs.functions_dropdown.clear();
      // v.uuid = "";
    },
    keyup(e) {
      let v = this;
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        v.send_prompt();
      }
    },
    edit_message(message, index) {
      let v = this;
      v.meta.settings.messages.map((m) => {
        m.is_editing = false;
      });
      message.is_editing = true;
    },
    init() {
      let v = this;
      v.$root.loader(true);
      post("/assistant/personality/init", v.meta)
        .then((r) => {
          let { template, reply } = r;
          v.meta.settings.messages = [];
          v.meta.settings.messages.push({
            role: "developer",
            content: template,
          });
          v.meta.settings.messages.push({
            role: "assistant",
            content: reply,
          });
          v.meta.settings.init_result = reply;
        })
        .catch((error) => {
          console.log("error", error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    functions_changed(functions) {
      let v = this;
      console.log("functions", functions);
      if (functions) {
        let actns;
        if (Array.isArray(functions)) {
          actns = functions.map((f) => {
            return {
              name: f.name,
              parameters: JSON.parse(f.settings.parameters),
            };
          });
        } else {
          actns = [
            {
              name: functions.name,
              parameters: JSON.parse(functions.settings.parameters),
            },
          ];
        }
        v.meta.settings.actions = JSON.stringify(actns, null, 2);
      } else v.meta.settings.actions = "";
    },
    init_prompt() {
      let v = this;
      v.$root.loader(true);
      post("/assistant/personality/init-prompt", v.meta)
        .then((r) => {
          console.log("init prompt response", r);
          let { template, reply } = r;
          v.meta.settings.messages = [];
          v.meta.settings.messages.push({
            role: "developer",
            content: template,
          });
          v.meta.settings.messages.push({
            role: "assistant",
            content: reply,
          });
          v.meta.settings.init_result = reply;
        })
        .catch((error) => {
          console.log("error", error);
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
